<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  errors: { type: Object, default: () => ({}) },
  form: { type: Object, required: true },
});

const emit = defineEmits(['updateCondition']);
const { t } = useI18n();
</script>

<template>
  <fieldset class="grid gap-3">
    <legend class="text-sm font-semibold text-lais-text">
      {{ t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.ONUS') }}
      {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.REQUIRED_INDICATOR') }}
    </legend>
    <div class="flex gap-3">
      <button
        v-for="option in ['1', '0']"
        :key="option"
        type="button"
        class="rounded-lais border px-5 py-2 text-sm font-semibold"
        :class="
          form.onus_solicitada === option
            ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
            : 'border-lais-border bg-white text-lais-text'
        "
        @click="emit('updateCondition', 'onus_solicitada', option)"
      >
        {{
          option === '1'
            ? t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.YES')
            : t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.NO')
        }}
      </button>
    </div>
    <p v-if="errors.onus" class="text-xs text-lais-danger">
      {{ errors.onus }}
    </p>
    <LaisField
      v-if="form.onus_solicitada === '0'"
      :label="t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.ONUS_REASON')"
      :error="errors.onus_reason"
      required
    >
      <textarea
        :value="form.justificativa_onus"
        rows="3"
        class="rounded-lais border border-lais-border bg-white px-3 py-2 text-sm"
        :placeholder="
          t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.ONUS_PLACEHOLDER')
        "
        @input="
          emit('updateCondition', 'justificativa_onus', $event.target.value)
        "
      />
    </LaisField>
  </fieldset>
</template>
